export default "__VITE_ASSET__CCnMIfkP__"